export default __webpack_public_path__ + "static/media/Rubik-Italic.4482c6ab.woff";